import {
  DropDownIcon,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import useLocalRouter from "@/hooks/use-router";
import { filter } from "@/types/gallery";

type MainFilterProps = {
  type: filter;
  setType: (d: filter) => void;
  options: string[];
};

const valueMap = ["Image", "Video", ""];

export function MainFilter({ type, setType, options }: MainFilterProps) {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger className="w-[160px] rounded-full bg-foreground px-3 py-3 text-sm text-secondary sm:w-[200px] sm:px-6 sm:py-4 sm:text-base">
        <div className="flex items-center justify-between gap-2">
          {type.title}
          <DropDownIcon />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-foreground text-secondary">
        {options?.map((option, index) => (
          <DropdownMenuItem
            key={option}
            className="cursor-pointer"
            onClick={() => setType({ title: option, value: valueMap[index] })}
          >
            {option}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export enum YearQuery {
  PERFORMANCE_YEAR = "perf-year",
  WINNERS_YEAR = "winners-year",
  CARPETS_YEAR = "carpets-year",
}

type YearFilterProps = {
  yearQuery: YearQuery;
  year: filter;
  setYear: (d: filter) => void;
  years: string[];
};

const valueMapYear = ["2025", "2024", "2023", "2022", ""];

export function YearFilter({
  yearQuery,
  years,
  year,
  setYear,
}: YearFilterProps) {
  const router = useLocalRouter();
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger className="w-[90px] rounded-full bg-foreground px-3 py-3 text-sm text-secondary sm:w-[120px] sm:px-6 sm:py-4 sm:text-base">
        <div className="flex items-center justify-between gap-2">
          {year.title}
          <DropDownIcon />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-foreground text-secondary">
        {years?.map((year, index) => (
          <DropdownMenuItem
            key={year}
            className="cursor-pointer !bg-opacity-100"
            onClick={() => {
              setYear({ title: year, value: valueMapYear[index] });
              router.push(
                {
                  search: {
                    [yearQuery]: valueMapYear[index],
                  },
                },
                {
                  scroll: false,
                },
              );
            }}
          >
            {year}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
